import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useStrictLocalization } from "@faire/web/common/localization";
import { damageMissing } from "../../instantAnswers/orders-damagedMissing";
import { failedDeliveryAttempt } from "../../instantAnswers/orders-failedDeliveryAttempt";
import { invoiceDetails } from "../../instantAnswers/orders-invoiceDetails";
import { payoutCalculation } from "../../instantAnswers/orders-payoutCalculation";
import { RequestCommissionChanges } from "../../instantAnswers/orders-requestCommissionChanges";
import { returnedToSender } from "../../instantAnswers/orders-returnedToSender";
import { orderDeliveredStateVisibilityFn, orderShippedOrDeliveredAndSOYOVisibilityFn } from "../../visibilityFunctions/orderStateVisibilityFn";
export var useOrderDeliveredBrandNodes = function useOrderDeliveredBrandNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var articles = useArticles();
  return {
    DamageMissingItemReportDeliveredState: {
      id: "DamageMissingItemReportDeliveredState",
      label: strictLocalize({
        id: "YJBiao",
        defaultMessage: "Damaged or missing item report"
      }),
      level: 2,
      isNodeVisible: orderDeliveredStateVisibilityFn,
      instantAnswer: damageMissing(strictLocalize)
    },
    PayoutCalculationDeliveredState: {
      id: "PayoutCalculationDeliveredState",
      label: strictLocalize({
        id: "/lzS+4",
        defaultMessage: "Payout calculation"
      }),
      level: 2,
      instantAnswer: payoutCalculation(strictLocalize),
      isNodeVisible: orderDeliveredStateVisibilityFn
    },
    InvoiceDetailsDeliveredState: {
      id: "InvoiceDetailsDeliveredState",
      label: strictLocalize({
        id: "OnTwIg",
        defaultMessage: "Invoice details"
      }),
      level: 2,
      instantAnswer: invoiceDetails(strictLocalize),
      articles: [articles.InvoicesAndBilling.RECEIVE_ORDER_INVOICE],
      isNodeVisible: orderDeliveredStateVisibilityFn
    },
    ProblemWithDeliveryDeliveredState: {
      id: "ProblemWithDeliveryDeliveredState",
      label: strictLocalize({
        id: "+ES+we",
        defaultMessage: "Problem with delivery"
      }),
      children: ["FailedDeliveryAttemptDeliveredState", "ReturnToSenderDeliveredState"],
      level: 2,
      isNodeVisible: orderDeliveredStateVisibilityFn
    },
    FailedDeliveryAttemptDeliveredState: {
      id: "FailedDeliveryAttemptDeliveredState",
      label: strictLocalize({
        id: "sm+jd/",
        defaultMessage: "Failed delivery attempt"
      }),
      level: 2,
      instantAnswer: failedDeliveryAttempt(strictLocalize),
      isNodeVisible: orderShippedOrDeliveredAndSOYOVisibilityFn
    },
    ReturnToSenderDeliveredState: {
      id: "ReturnToSenderDeliveredState",
      label: strictLocalize({
        id: "l/7+5Z",
        defaultMessage: "Return to sender"
      }),
      level: 2,
      instantAnswer: returnedToSender(strictLocalize),
      articles: [articles.MyOrders.ORDER_RETURNED_TO_SENDER],
      isNodeVisible: orderDeliveredStateVisibilityFn
    },
    RequestCommissionChangesDeliveredState: {
      id: "RequestCommissionChangesDeliveredState",
      label: strictLocalize({
        id: "/jYVoe",
        defaultMessage: "Request commission change"
      }),
      level: 2,
      isNodeVisible: orderDeliveredStateVisibilityFn,
      instantAnswer: RequestCommissionChanges(strictLocalize),
      articles: [articles.FaireDirect.ZERO_COMMISSION]
    }
  };
};